import React, { Component } from "react";

import { CommonService } from "../js_modules/CommonService";

import { TenantSiteOfferCalculationQueryComponent } from "./TenantSiteOfferCalculationQueryComponent";
import { TenantSiteOfferMMRCalculationComponent } from "./TenantSiteOfferMMRCalculationComponent";

export class TenantSiteOfferCalculationComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoadingData: false,
            tenants: null,
            tableData: [],
            tableTitle: "",
            paintTable: true,
            mmrTableData: [],
            showAddDialog: false,
            showBulkEditDialog: false,
            selectedSite: null,
            selectedTenant: null,
            filterValue: "",
            canEdit: false
        };

        this.onGetClick = this.onGetClick.bind(this);
        this.onCancelAddClick = this.onCancelAddClick.bind(this);
        this.onAddClick = this.onAddClick.bind(this);
        this.onBulkEditClick = this.onBulkEditClick.bind(this);
        this.onLookupClick = this.onLookupClick.bind(this);
        this.onRowSelectChanged = this.onRowSelectChanged.bind(this);

        props.onPageChanged({
            pageTitle: this.pageTitle
        });
    }

    pageTitle = "Offer Calculation";

    componentDidMount() {
        try {
            this.props.applicationInsights.trackPageView({ name: this.pageTitle, url: "/Tenant/OfferCalculation", pageType: "Consumer/Admin", isLoggedIn: "Yes", properties: { logon: this.props.logon } });
            CommonService.clientAzureStorageLog("TenantSiteOfferCalculationComponent", "componentDidMount", null, null, null, null, this.props.applicationInsights);
            this.getTenants();
            this.onLookupClick();
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferCalculationComponent", "componentDidMount");
        }
    }

    getTenants() {
        try {
            this.setState({ isLoadingData: true });
            this.props.applicationInsights.trackTrace({ message: "TenantSiteOfferCalculationComponent/getTenants", properties: { logon: this.props.logon } });
            fetch("/TenantSite/GetTenants", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;"
                },
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    this.setState({
                        isLoadingData: false,
                        tenants: parsedResponse.result,
                        canEdit: parsedResponse.isInEditRole
                    });
                })
                .catch(notOKResponse => {
                    this.setState({
                        isLoadingData: false
                    });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/TenantSite/GetTenants", ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "TenantSiteOfferCalculationComponent", "getTenants");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "TenantSiteOfferCalculationComponent", "getTenants");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferCalculationComponent", "getTenants");
        }
    }

    loadMMROfferCalculation() {
        let inputData = {
            siteGuid: this.state.selectedSite.guid
        };
        this.props.applicationInsights.trackTrace({ message: "TenantSiteOfferCalculationComponent/onGetClick", properties: { ...inputData, logon: this.props.logon } });
        fetch("/TenantSite/GetSiteCalculationConfigMMR", {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8;"
            },
            body: JSON.stringify(inputData),
            credentials: "same-origin"
        })
            .then(response => { if (response.ok) { return response.json() } else { throw response; } })
            .then(parsedResponse => {
                let defaultRow = parsedResponse.table.filter(scv => scv.isDefault)[0];
                parsedResponse.table.forEach((rowData, index) => {
                    rowData.rowClassName = !rowData.enableOfferCalculation ? "app-sell-trade-offer-calculation-disabled" : "";
                    rowData.accidentAdjustmentIsDollarLabel = "No";
                    rowData.accidentAdjustmentIsDollarLabel2 = "Yes";
                    rowData.generalAdjustmentIsDollarLabel = "No";
                    rowData.generalAdjustmentIsDollarLabel2 = "Yes";
                    rowData.enableOfferCalculation_groupClassName = "justify-content-center";
                    rowData.odometerAdjustmentEnabled_groupClassName = "justify-content-center";
                    rowData.forecastAdjustmentEnabled_groupClassName = "justify-content-center";
                    if (!this.state.canEdit) {
                        rowData.disableEdit = true;
                    }

                    if (rowData.isDefault) {
                        rowData.disableEdit = true;
                    }
                    else {
                        if (rowData.maximumOfferAmount === null) {
                            rowData.maximumOfferAmount = defaultRow.maximumOfferAmount;
                        }
                        else {
                            rowData.maximumOfferAmount_cellClassName = "admin-table-cell-different-from-default-bg";
                        }
                        if (rowData.maximumOdometer === null) {
                            rowData.maximumOdometer = defaultRow.maximumOdometer;
                        }
                        else {
                            rowData.maximumOdometer_cellClassName = "admin-table-cell-different-from-default-bg";
                        }
                        if (rowData.minimumYear === null) {
                            rowData.minimumYear = defaultRow.minimumYear;
                        }
                        else {
                            rowData.minimumYear_cellClassName = "admin-table-cell-different-from-default-bg";
                        }
                        if (rowData.minimumAverageGrade === null) {
                            rowData.minimumAverageGrade = defaultRow.minimumAverageGrade;
                        }
                        else {
                            rowData.minimumAverageGrade_cellClassName = "admin-table-cell-different-from-default-bg";
                        }
                        if (rowData.gradeLikeNewConditionValue === null) {
                            rowData.gradeLikeNewConditionValue = defaultRow.gradeLikeNewConditionValue;
                        }
                        else {
                            rowData.gradeLikeNewConditionValue_cellClassName = "admin-table-cell-different-from-default-bg";
                        }
                        if (rowData.gradeVeryGoodConditionValue === null) {
                            rowData.gradeVeryGoodConditionValue = defaultRow.gradeVeryGoodConditionValue;
                        }
                        else {
                            rowData.gradeVeryGoodConditionValue_cellClassName = "admin-table-cell-different-from-default-bg";
                        }
                        if (rowData.gradeAcceptableConditionValue === null) {
                            rowData.gradeAcceptableConditionValue = defaultRow.gradeAcceptableConditionValue;
                        }
                        else {
                            rowData.gradeAcceptableConditionValue_cellClassName = "admin-table-cell-different-from-default-bg";
                        }
                        if (rowData.gradeMajorIssuesConditionValue === null) {
                            rowData.gradeMajorIssuesConditionValue = defaultRow.gradeMajorIssuesConditionValue;
                        }
                        else {
                            rowData.gradeMajorIssuesConditionValue_cellClassName = "admin-table-cell-different-from-default-bg";
                        }
                        if (rowData.tireAdjustmentBelowThresholdAmount === null) {
                            rowData.tireAdjustmentBelowThresholdAmount = defaultRow.tireAdjustmentBelowThresholdAmount;
                        }
                        else {
                            rowData.tireAdjustmentBelowThresholdAmount_cellClassName = "admin-table-cell-different-from-default-bg";
                        }
                        if (rowData.tireAdjustmentAboveThresholdAmount === null) {
                            rowData.tireAdjustmentAboveThresholdAmount = defaultRow.tireAdjustmentAboveThresholdAmount;
                        }
                        else {
                            rowData.tireAdjustmentAboveThresholdAmount_cellClassName = "admin-table-cell-different-from-default-bg";
                        }
                        if (rowData.tireAdjustmentThreshold === null) {
                            rowData.tireAdjustmentThreshold = defaultRow.tireAdjustmentThreshold;
                        }
                        else {
                            rowData.tireAdjustmentThreshold_cellClassName = "admin-table-cell-different-from-default-bg";
                        }
                        if (rowData.windshieldAdjustmentBelowThresholdAmount === null) {
                            rowData.windshieldAdjustmentBelowThresholdAmount = defaultRow.windshieldAdjustmentBelowThresholdAmount;
                        }
                        else {
                            rowData.windshieldAdjustmentBelowThresholdAmount_cellClassName = "admin-table-cell-different-from-default-bg";
                        }
                        if (rowData.windshieldAdjustmentAboveThresholdAmount === null) {
                            rowData.windshieldAdjustmentAboveThresholdAmount = defaultRow.windshieldAdjustmentAboveThresholdAmount;
                        }
                        else {
                            rowData.windshieldAdjustmentAboveThresholdAmount_cellClassName = "admin-table-cell-different-from-default-bg";
                        }
                        if (rowData.windshieldAdjustmentThreshold === null) {
                            rowData.windshieldAdjustmentThreshold = defaultRow.windshieldAdjustmentThreshold;
                        }
                        else {
                            rowData.windshieldAdjustmentThreshold_cellClassName = "admin-table-cell-different-from-default-bg";
                        }
                        if (rowData.generalAdjustmentValue === null) {
                            rowData.generalAdjustmentIsDollar = defaultRow.generalAdjustmentIsDollar;
                            rowData.generalAdjustmentValue = defaultRow.generalAdjustmentValue;
                        }
                        else {
                            rowData.generalAdjustmentValue_cellClassName = "admin-table-cell-different-from-default-bg";
                        }
                        if (rowData.accidentAdjustmentValue === null) {
                            rowData.accidentAdjustmentIsDollar = defaultRow.accidentAdjustmentIsDollar;
                            rowData.accidentAdjustmentValue = defaultRow.accidentAdjustmentValue;
                        }
                        else {
                            rowData.accidentAdjustmentValue_cellClassName = "admin-table-cell-different-from-default-bg";
                        }
                        if (rowData.wholesaleAdjustmentValue === null) {
                            rowData.wholesaleAdjustmentIsDollar = defaultRow.wholesaleAdjustmentIsDollar;
                            rowData.wholesaleAdjustmentValue = defaultRow.wholesaleAdjustmentValue;
                        }
                        else {
                            rowData.wholesaleAdjustmentValue_cellClassName = "admin-table-cell-different-from-default-bg";
                        }
                        if (rowData.odometerAdjustmentEnabled === null) {
                            rowData.odometerAdjustmentEnabled = defaultRow.odometerAdjustmentEnabled;
                        }
                        else {
                            rowData.odometerAdjustmentEnabled_cellClassName = rowData.odometerAdjustmentEnabled !== defaultRow.odometerAdjustmentEnabled ? "admin-table-cell-different-from-default-bg" : "";
                        }
                        if (rowData.forecastAdjustmentEnabled === null) {
                            rowData.forecastAdjustmentEnabled = defaultRow.forecastAdjustmentEnabled;
                        }
                        else {
                            rowData.forecastAdjustmentEnabled_cellClassName = rowData.forecastAdjustmentEnabled !== defaultRow.forecastAdjustmentEnabled ? "admin-table-cell-different-from-default-bg" : "";
                        }
                    }
                    if (rowData.accidentAdjustmentIsDollar) {
                        rowData.accidentAdjustmentValue_dataType = "money";
                    }
                    else {
                        rowData.accidentAdjustmentValue_dataType = "percent_1";
                    }
                    if (rowData.generalAdjustmentIsDollar) {
                        rowData.generalAdjustmentValue_dataType = "money";
                    }
                    else {
                        rowData.generalAdjustmentValue_dataType = "percent_1";
                    }
                    if (rowData.wholesaleAdjustmentIsDollar) {
                        rowData.wholesaleAdjustmentValue_dataType = "money";
                    }
                    else {
                        rowData.wholesaleAdjustmentValue_dataType = "percent_1";
                    }

                    if (this.state.mmrTableData.filter(row => row.id === rowData.id && row.isSelected).length === 1) {
                        rowData.isSelected = true;
                    }
                });

                let mmrTableData = CommonService.addOrdinalColumn(parsedResponse.table);
                let filterTableData = this.searchData(this.state.filterValue, mmrTableData);
                this.setState({
                    mmrTableData: mmrTableData,
                    filterTableData: filterTableData,
                    tableTitle: this.state.selectedTenant.name + " - " + this.state.selectedSite.siteName,
                    paintTable: true,
                    isLoadingData: false
                }, this.setState({ paintTable: false }));
            })
            .catch(notOKResponse => {
                this.setState({
                    isLoadingData: false
                });
                if (notOKResponse.status === 500) {
                    notOKResponse.json()
                        .then(parsedError => {
                            this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/TenantSite/GetSiteCalculationConfigMMR", ...inputData, ...parsedError, logon: this.props.logon } });
                            console.logError(parsedError, "TenantSiteOfferCalculationComponent", "onGetClick");
                            this.props.onShowAlert("danger", parsedError);
                        })
                        .catch(jsonParseError => {
                            console.logError(jsonParseError, "TenantSiteOfferCalculationComponent", "onGetClick");
                        });
                }
            });
    }

    onGetClick(selectedTenant, selectedSite) {
        try {
            this.setState({
                isLoadingData: true,
                selectedTenant: selectedTenant,
                selectedSite: selectedSite
            }, () => {
                this.loadMMROfferCalculation();
            });
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferCalculationComponent", "onGetClick");
        }
    }

    onAddClick(event) {
        try {
            if (this.state.mmrTableData.length === 0) {
                this.props.onShowAlert("warning", { message: "Default Offer Calculation is required." }, 4000);
            }
            else {
                this.setState({ showAddDialog: true });
            }
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferCalculationComponent", "onAddClick");
        }
    }

    onBulkEditClick(event) {
        try {
            this.setState({ showBulkEditDialog: true });
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferCalculationComponent", "onBulkEditClick");
        }
    }

    onCancelAddClick() {
        try {
            this.setState({
                showAddDialog: false,
                showBulkEditDialog: false
            });
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferCalculationComponent", "onCancelAddClick");
        }
    }

    onLookupClick(filterValue) {
        try {
            let filterTableData = this.searchData(filterValue, this.state.mmrTableData);
            this.setState({
                filterValue: filterValue,
                filterTableData: filterTableData,
                paintTable: true
            }, () => {
                this.setState({ paintTable: false });
            });
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferCalculationComponent", "onLookupClick");
        }
    }

    onRowSelectChanged(selectedRows) {
        try {
            let mmrTableData = this.state.mmrTableData;
            this.setState({ mmrTableData: mmrTableData });
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferCalculationComponent", "onRowSelectChanged");
        }
    }

    searchData(filterValue, mmrTableData) {
        let filterRegex = new RegExp(filterValue, "i");
        let filterTableData = mmrTableData.filter(rowData => filterRegex.test(rowData.make) || filterRegex.test(rowData.year) || filterRegex.test(rowData.model) || filterRegex.test(rowData.comments));
        mmrTableData.filter(rowData => !(filterRegex.test(rowData.make) || filterRegex.test(rowData.year) || filterRegex.test(rowData.model) || filterRegex.test(rowData.comments)))
            .forEach((row) => { row.isSelected = false });

        return filterTableData;
    }

    render() {
        return <div className="admin-body admin-fill-content">
            <div className="d-flex flex-column admin-fill-content">
                <TenantSiteOfferCalculationQueryComponent
                    tenants={this.state.tenants}
                    canEdit={this.state.canEdit}
                    onAddClick={this.onAddClick}
                    onBulkEditClick={this.onBulkEditClick}
                    onGetClick={this.onGetClick}
                    onSiteClick={this.onSiteClick}
                    onTenantClick={this.onTenantClick}
                    isLoadingData={this.state.isLoadingData}
                    isGlobalAdmin={this.props.isGlobalAdmin}
                    applicationInsights={this.props.applicationInsights}
                    logon={this.props.logon}
                    onLookupClick={this.onLookupClick}
                    enableBulkEdit={this.state.mmrTableData.filter((row) => row.isSelected).length > 0}
                />
                <br />
                {
                    this.state.selectedSite
                        ? <TenantSiteOfferMMRCalculationComponent
                            canEdit={this.state.canEdit}
                            onShowAlert={this.props.onShowAlert}
                            tableTitle={this.state.tableTitle}
                            tableData={this.state.filterTableData}
                            paintTable={this.state.paintTable}
                            defaultRow={this.state.mmrTableData !== null ? this.state.mmrTableData.filter(row => row.isDefault)[0] : null}
                            selectedSite={this.state.selectedSite}
                            selectedTenant={this.state.selectedTenant}
                            applicationInsights={this.props.applicationInsights}
                            showAddDialog={this.state.showAddDialog}
                            showBulkEditDialog={this.state.showBulkEditDialog}
                            selectedRows={this.state.mmrTableData.filter((row) => row.isSelected)}
                            onGetClick={this.onGetClick}
                            onCancelAddClick={this.onCancelAddClick}
                            onLookupClick={this.onLookupClick}
                            onRowSelectChanged={this.onRowSelectChanged}
                        />
                        : null
                }
            </div>
        </div>;
    }
}